import React from 'react';

function DashboardCardWrapper({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', width: '100%', justifyContent: 'center' }}>{children}</div>
  );
}

export default DashboardCardWrapper;
